<div class="smooth-scrolling">

<section class="skincare">
    <div class="row">
      <div class="col-lg-3  leftSide new-blog-search d-lg-none d-block">
        <div class="bl-search" [formGroup]="blogSearchForm">
          <div class="search-inputbox" (click)="clickSearch()">
            <input type="search" placeholder="Search blog" name="blog-search" id="blog-search" formControlName="search">
            <div class="search-btn"><input type="submit"><img src="assets/images/search-icon-dark.svg" /></div>
          </div>
          <div [ngClass]="show ? 'open-search-bar':''">
            <ul class="scrollbar" *ngIf="mblogResponse && mblogResponse?.data && mblogResponse.data[0]?.id && show; else noData">
              <li *ngFor="let blogList of mblogResponse?.data">
                <span class="search-icon-new"><img src="/assets/images/search-black-nav.svg" alt="icon"></span>
                <a (click)="openSearchBlogDetail(blogList)">{{blogList?.title}}</a></li>
            </ul>

            <ng-template #noData>
              <ul *ngIf="show" class="no-data-h">
                <li>
                  <span class="search-icon-new"><img src="/assets/images/search-black-nav.svg" alt="icon"></span>
                  <small>No Data Found</small>
                </li>
              </ul>
            </ng-template>
          </div>
          <div [ngClass]="historyShow ? 'open-search-bar':''">
            <ul class="scrollbar" *ngIf="historyShow && arrSearchHistory && arrSearchHistory.length>0">
              <li class="bold">History</li>
              <li *ngFor="let history of arrSearchHistory">
                <span class="search-icon-new"><img src="/assets/images/search-history-icon.png" alt="icon"></span>
                <a (click)="openSearchBlogDetail(history)">{{history.title}}</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="top-breadcrunbs mt-lg-4 mt-0 d-lg-none d-block mobile-breadcrunbs">
        <ul>
          <li *ngIf="subCategoryName !== undefined && subCategoryName !== null && subCategoryName !== '' && subCategoryName.length > 0"><a [href]="'/blog-list/'+categoryId"><img src="assets/images/back-arrow.svg" alt="" (click)="backClick()"></a></li>
          <li *ngIf="subCategoryName == undefined || subCategoryName == null || subCategoryName == ''"><a outerLink="/blog"><img src="assets/images/back-arrow.svg" alt="" (click)="backClick()"></a></li>
          <li class="breadcrumb-item"><a (click)="openAllBlogs()">Blogs</a></li>
          <li class="breadcrumb-item" aria-current="page" *ngIf="categoryNameArray!=null && categoryNameArray!=undefined && categoryNameArray.length>0"><a [href]="'/blog-list/'+categoryId">{{ categoryNameArray[0]?.name?.length ?? 0 > 15 ? (categoryNameArray[0]?.name | slice:0:15) : categoryNameArray[0]?.name }}</a></li>
          <li class="breadcrumb-item" aria-current="page" *ngIf="subCategoryName !== undefined && subCategoryName !== null && subCategoryName !== '' && subCategoryName.length > 0"><a>{{ subCategoryName?.length ?? 0 > 15 ? (subCategoryName | slice:0:15) : subCategoryName }}</a> </li>
          <li class="breadcrumb-item" aria-current="page" *ngIf="newTrend && newTrend == true"><a>Trending</a> </li>
        </ul>
      </div>
        <div class="col-lg-12">
            <div class="heading" *ngIf="categoryNameArray && categoryNameArray.length>0">
                <h4 *ngIf="categoryNameArray[0]?.name == 'Skin Care 101' || categoryNameArray[0]?.id=='44' || categoryNameArray[0]?.id == 44; else otherCategory">Skincare<span>101</span></h4>
                <ng-template #otherCategory>
                    <h4>{{categoryNameArray[0]?.name}}</h4>
                </ng-template>
                <div class="sub-title" *ngIf="categoryNameArray[0]?.name == 'Skin Care 101' || categoryNameArray[0]?.id=='44' || categoryNameArray[0]?.id == 44">What's the fun without 101?</div>
              </div>
        </div>
    </div>
    <div class="row align-items-center">
        <div class="col-lg-3  leftSide new-blog-search d-none d-lg-flex">
            <div class="bl-search" [formGroup]="blogSearchForm">
              <div class="search-inputbox" (click)="clickSearch()">
                <input type="search" placeholder="Search blog" name="blog-search" id="blog-search" formControlName="search">
                <div class="search-btn"><input type="submit"><img src="assets/images/search-icon-dark.svg" /></div>
              </div>
              <div [ngClass]="show ? 'open-search-bar':''">
                <ul class="scrollbar" *ngIf="mblogResponse && mblogResponse?.data && mblogResponse.data[0]?.id && show; else noData">
                  <li *ngFor="let blogList of mblogResponse?.data">
                    <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                    <a (click)="openSearchBlogDetail(blogList)">{{blogList?.title}}</a></li>
                </ul>

                <ng-template #noData>
                  <ul *ngIf="show" class="no-data-h">
                    <li>
                      <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                      <small>No Data Found</small>
                    </li>
                  </ul>
                </ng-template>
              </div>
              <div [ngClass]="historyShow ? 'open-search-bar':''">
                <ul class="scrollbar" *ngIf="historyShow && arrSearchHistory && arrSearchHistory.length>0">
                  <li class="bold">History</li>
                  <li *ngFor="let history of arrSearchHistory">
                    <span class="search-icon-new"><img src="assets/images/search-history-icon.png" alt="icon"></span>
                    <a (click)="openSearchBlogDetail(history)">{{history.title}}</a></li>
                </ul>
              </div>
            </div>
          </div>
        <div class="col-lg-9">
            <div class="blog-nav">
                <ul *ngIf="newTrend == null">
                    <li *ngFor="let cat of subCategoryList; let i = index">
                        <a [ngClass]="cat.id == categoryId ? 'active' : ''"
                            (click)="getNewBlogList(cat.id, cat.name)">{{cat.name}}</a>
                    </li>
                </ul>
                <ul *ngIf="newTrend && newTrend == true">
                  <li *ngFor="let cat of mCategoryResponseModal.data; let i = index">
                      <a [ngClass]="cat.id == categoryId ? 'active' : ''"
                          (click)="rediretToBlogList(cat.id)">{{cat.name}}</a>
                  </li>
              </ul>
            </div>
        </div>
      </div>
</section>

<div class="top-breadcrunbs mt-lg-4 mt-0 d-lg-flex d-none">
  <ul>
    <li *ngIf="subCategoryName !== undefined && subCategoryName !== null && subCategoryName !== '' && subCategoryName.length > 0"><a [href]="'/blog-list/'+categoryId"><img src="assets/images/back-arrow.svg" alt="" (click)="backClick()"></a></li>
    <li *ngIf="subCategoryName == undefined || subCategoryName == null || subCategoryName == ''"><a outerLink="/blog"><img src="assets/images/back-arrow.svg" alt="" (click)="backClick()"></a></li>
    <li class="breadcrumb-item"><a (click)="openAllBlogs()">Blogs</a></li>
    <li class="breadcrumb-item" aria-current="page" *ngIf="categoryNameArray!=null && categoryNameArray!=undefined && categoryNameArray.length>0"><a [href]="'/blog-list/'+categoryId">{{ categoryNameArray[0]?.name?.length ?? 0 > 15 ? (categoryNameArray[0]?.name | slice:0:15) : categoryNameArray[0]?.name }}</a></li>
    <li class="breadcrumb-item" aria-current="page" *ngIf="subCategoryName !== undefined && subCategoryName !== null && subCategoryName !== '' && subCategoryName.length > 0"><a>{{ subCategoryName?.length ?? 0 > 15 ? (subCategoryName | slice:0:15) : subCategoryName }}</a> </li>
    <li class="breadcrumb-item" aria-current="page" *ngIf="newTrend && newTrend == true"><a>Trending</a> </li>
  </ul>
</div>

<section class="blog-detail-list" [ngStyle]="{'background-color': (categoryColor && categoryColor != '') ? categoryColor : 'transparent'}">
    <div class="row"  *ngIf="blogs && blogs.length>0">
        <div class="col-lg-4 col-sm-6 col-12 mb-lg-4 mb-3 blog-list-m" *ngFor="let blog of blogs; let i = index">
          <app-list-blogs [categoryList]="mCategoryResponseModal?.data" [blog]="blog"></app-list-blogs>
        </div>
    </div>
      <div class="no-data-found" *ngIf="blogs && blogs.length < 1 && !isLoadingBlog">
        No Data Found!
    </div>
    <div class="col-12" *ngIf="(blogs && blogs.length>0) && (this.totalRecord > (blogs.length + 1))">
        <div class="more-result">
            <a (click)="showMoreResults()">More Results</a>
        </div>
    </div>
</section>
<div class="bigger-text-section d-lg-flex d-none">
    <div class="textWrap">
      <div class="line">
        <span class="gr-text">Beauty</span>
        <span class="light-text">is</span>
        <span class="gr-text">personal</span><br>
        <div class="btn-line-01">
          <span class="light-text">so why</span>
          <span class="dark-text">settle</span>
        </div>
        <div class="btn-line-02">
          <span class="light-text">for a</span>
          <span class="light-text">one-size</span>
        </div>
        <span class="gr-text">fits-all approach?</span>
        <div class="book-free-and-the-skin-test-btn">
          <ul class="w-100">
            <li class="new-take-btn">
              <a (click)="commingSoon()">
                take the skin test
                <i class="fa-solid fa-arrow-right arrow-icon"></i>
              </a>
          </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer-bg></app-footer-bg>